'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function groupBy(arr, getKeyFromItem) {
    var result = {};
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var key = getKeyFromItem(item);
        if (!Object.hasOwn(result, key)) {
            result[key] = [];
        }
        result[key].push(item);
    }
    return result;
}
exports.groupBy = groupBy;
